import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-string',
  templateUrl: './d-con-string.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConStringComponent),
      multi: true
    }
  ]
})
export class DConStringComponent extends DynamicComponentBase {
  static KEY = 'd-con-string';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.effective) {
      config.effective = [];
    }
  }
}
